<template>
  <b-modal
    v-model="$show"
    :title="`Submit Evidence`"
    content-class="modal__submission-confirmation"
    body-class="modal__submission-body"
    size="lg"
    centered
    no-close-on-backdrop
    no-close-on-esc
    @close="closeModal()"
  >
    <template>
      <div class="submission-intro">
        <div class="icon-container">
          <b-img :src="BookIconSvg" />
        </div>
        <p class="mt-1 submission-title">Enhance your skills</p>
      </div>
      <div class="submission-guide">
        <p class="font-weight-bold mb-0">How to submit evidence</p>
        <ol class="mt-1 list__submission-guide">
          <li class="mt-1 p-0">Read description and assessment criteria of each part.</li>
          <li class="mt-1 p-0">Type or attach file to submit as an evidence.</li>
        </ol>
      </div>
      <div class="submission-details row m-0">
        <div class="col detail-column detail-column__left">
          <b-img :src="CheckIconSvg" />
          <div class="text__detail">
            <p class="font-weight-bold m-0">2 submission quotas</p>
            <p class="m-0">to verify competency</p>
          </div>
        </div>
        <div class="col detail-column detail-column__right">
          <b-img :src="TimeIconSvg" />
          <div class="text__detail">
            <p class="font-weight-bold m-0">No time limit</p>
            <p class="m-0">submission</p>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <p class="font-weight-bold mb-0">Start Submit Evidence</p>
        <span>Provide the evidence using the method to verify your skill.</span>
      </div>
    </template>
    <template #modal-footer>
      <b-button
        ref="button-confirm"
        class="btn-submit-confirm"
        variant="success"
        @click="clickConfirm()"
      >
        OK, Submit Now
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import BookIconSvg from '@/assets/icons/book-green.svg';
import CheckIconSvg from '@/assets/icons/square-check-green.svg';
import TimeIconSvg from '@/assets/icons/time-green.svg';

export default {
  components: {},
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      BookIconSvg,
      CheckIconSvg,
      TimeIconSvg
    };
  },
  computed: {
    $show: {
      get() {
        return this.showModal;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    }
  },
  methods: {
    clickConfirm() {
      this.$emit('confirmed');
    },

    closeModal() {
      this.$emit('canceled');
    }
  }
};
</script>

<style lang="scss" scoped>
.submission-intro {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;

  .icon-container {
    padding: 16px;
    width: 64px;
    height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #e5f9ed;
    border-radius: 50%;
    .icon-book-green {
      width: 28px;
    }
  }
  .submission-title {
    font-size: 20px;
    font-weight: 700;
  }
}

.submission-guide {
  .list__submission-guide {
    padding-inline-start: 20px;
  }
}
.submission-details {
  gap: 12px;

  .detail-column {
    background-color: #e5f9ed;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px 8px;
  }
}

::v-deep .modal-title {
  font-size: 18px;
}
::v-deep .modal-body {
  padding: 20px;
}

::v-deep .modal-dialog {
  max-width: 600px;
  margin: 0 auto;
}

/* For small screens (max-width: 375px) */
@media (max-width: 375px) {
  ::v-deep .modal-dialog {
    max-width: 335px;
  }
}

/* For medium screens (376px to 575px) */
@media (min-width: 376px) and (max-width: 575px) {
  ::v-deep .modal-dialog {
    max-width: 400px;
  }
}

/* For larger medium screens (576px to 767px) */
@media (min-width: 576px) and (max-width: 767px) {
  ::v-deep .modal-dialog {
    max-width: 496px;
  }
}

/* Adjust layout for small screens (max-width: 575px) */
@media screen and (max-width: 575px) {
  .row.submission-details {
    flex-direction: column;
  }

  .submission-details .detail-column {
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 1rem;
  }
}
</style>
